<template>
	<vx-card
        v-if="
                $store.state.auth.role === 'manager'
            "
    >
		<div class="vx-row">
			<div class="vx-col pt-2 pb-4"
			>
                <strong>{{ $t('last50MessagesManager') }} </strong>
            </div>
		</div>
        <hr class="mb-3 mt-3">
        <div v-if="listMessage.length > 0">
            <template
                v-for="(data, index) in listMessage"
            >
                <div class="mb-1 frsTitileOrderComment">
                    <vs-button @click="$router.push('/ticket/' + data.orderId )"
                        class="mb-3 mt-3"
                    >
                        {{ $t('ticket') }}: 
                        {{ data.orderId }}
                    </vs-button>
                    <div class="frsDateOrderComment">{{ data.date }}</div>
                </div>
                <div class="mb-1 frsTextOrderComment" v-html="data.message">
                </div>
                <hr class="mb-3 mt-3">
            </template>
        </div>
        <div v-else class="text-center">
            {{ $t('noLast50MessagesManager') }}
        </div>
    </vx-card>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";

    export default {
        name: "Last50MessagesManager",
        mixins: [databaseManager, notifier],
        props: {
            model: 		            { default: null },
            countOrderComments:     { default: null },
        },
        components: {

        },
        data() {
            return {
                listMessage:  { default: [] },
                addOrderCommentModal: false,
            }
        },
        methods: {
            async get50Messages() {
                this.listMessage = await this.dbLast50MessagesManager();
            },
        },
        async mounted() {
            try {
                await this.get50Messages();
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    }
</script>

<style lang="scss">
    .frsTitileOrderComment {
        display: flex;
        width: 100%;
    }
    .frsTextOrderComment {
        width: 100%;
    }
    .frsUserOrderComment {
        padding: 0 5px 0 0;
    }
    .frsDateOrderComment {
        margin-left: auto;
        padding: 0 0 0 5px;
    }
</style>